<!-- src/components/map/ItemsDrawer.vue -->
<template>
  <aside class="filters-drawer items-drawer" :class="{ open: openProp }" :aria-hidden="!openProp">
    <div class="drawer-header">
      <h3>Образцы в точке</h3>
    </div>

    <div class="drawer-body" v-if="openProp">
      <div v-if="!items || items.length === 0" class="empty">Нет образцов в точке</div>

      <ul class="items-list" v-else>
        <li
          v-for="it in sortedItems"
          :key="itKey(it)"
          class="item-row"
          :class="{ selected: isSelected(it) }"
          @click="selectItem(it)"
        >
          <!-- Превью удалено по задаче: просто мета-данные -->
          <div class="meta">
            <div class="row">
              <div class="label">Номер образца</div>
              <div class="value">{{ displayId(it) }}</div>
            </div>
            <div class="row">
              <div class="label">Генезис</div>
              <div class="value">{{ it.sample_origin_class || it.__raw?.sample_origin_class || '—' }}</div>
            </div>
            <div class="row">
              <div class="label">Масштаб</div>
              <div class="value">{{ it.research_scale || it.__raw?.research_scale || '—' }}</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'ItemsDrawer',
  props: {
    open: { type: Boolean, default: false },
    items: { type: Array, default: () => [] },
    // новый проп: выбранный элемент (объект или id)
    selectedItem: { type: [Object, String, Number], default: null }
  },
  emits: ['update:open','select-item'],
  computed: {
    openProp: {
      get(){ return this.open },
      set(v){ this.$emit('update:open', v) }
    },

    // отсортированный массив (по renamed_id, затем internal_id, затем id)
    sortedItems() {
      if (!Array.isArray(this.items)) return []
      return [...this.items].sort((a,b) => {
        const ka = (this.displayId(a) || '').toString().toLowerCase()
        const kb = (this.displayId(b) || '').toString().toLowerCase()
        if (ka < kb) return -1
        if (ka > kb) return 1
        return 0
      })
    }
  },
  methods: {
    // универсальная функция для ключа list item
    itKey(it) {
      const raw = it.__raw || it
      return it.id || it.internal_id || raw.internal_id || raw.id || Math.random().toString(36).slice(2)
    },

    // получить отображаемый идентификатор образца
    displayId(it) {
      const raw = it.__raw || it
      return it.renamed_id || raw.renamed_id || it.internal_id || raw.internal_id || it.id || raw.id || ''
    },

    // проверка, выбран ли элемент (поддерживает объект/строку/число)
    isSelected(it) {
      if (!this.selectedItem) return false
      const sel = this.selectedItem
      const raw = it.__raw || it
      const idCandidates = [it.id, it.internal_id, it.renamed_id, raw.id, raw.internal_id, raw.renamed_id].map(v => v === undefined ? null : String(v))
      const selStr = typeof sel === 'object' ? (String(sel.id || sel.internal_id || sel.renamed_id || '')) : String(sel)
      return idCandidates.includes(selStr)
    },

    selectItem(it) {
      this.$emit('select-item', it)
    }
  }
}
</script>

<style scoped>
.items-drawer {
  position: fixed;
  top: var(--filters-top, calc(var(--header-height, 64px) + var(--top-controls-height, 72px)));
  left: 24px;
  min-width: 320px;
  width: auto;
  max-width: 520px;
  background: rgba(246,246,246,0.98);
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0,0,0,0.12);
  padding: 8px;
  z-index: 1300;
  transform: translateX(-110%);
  opacity: 0;
  pointer-events: none;
  transition: transform .28s, opacity .18s;
  box-sizing: border-box;
  overflow: visible; /* позволяем внутренней области контролировать прокрутку */

  /* общая максимальная высота (будет применена при open) — значение оставлено как резерв */
  max-height: calc(100vh - var(--header-height, 64px) - var(--map-footer-space, 120px) - 76px);
  display: block;
}

/* открытая версия: колоночный flex, позволяющий body прокручиваться, footer быть фиксированным внизу */
.items-drawer.open {
  transform: translateX(0);
  opacity: 1;
  pointer-events: auto;

  /* запас над футером (учитывается в max-height, а не через bottom) */
  max-height: calc(100vh - var(--filters-top, calc(var(--header-height,64px) + var(--top-controls-height,72px))) - (var(--map-footer-space, 120px) + 12px));

  display: flex;
  flex-direction: column;
}

/* header */
.drawer-header { flex: 0 0 auto; }
.drawer-header h3 { margin:0; padding:6px 8px; font-size:16px; color:#222222; }

/* body: гибкая прокручиваемая зона */
.drawer-body {
  flex: 0 1 auto;
  min-height: 0;
  /* Вычисляем max-height для body на основе общей доступной max-height панели
     и фиксированной высоты header/paddings (можно скорректировать через --items-fixed-height) */
  max-height: calc(
    (100vh - var(--filters-top, calc(var(--header-height,64px) + var(--top-controls-height,72px))) - (var(--map-footer-space, 120px) + 12px))
    - var(--items-fixed-height, 64px)
  );
  overflow-y: auto;
  padding-right: 8px;
  padding-bottom: 8px;
}

/* список элементов */
.items-list { list-style:none; padding:0; margin:0; display:flex; flex-direction:column; gap:8px }
.item-row {
  display:flex; gap:12px; padding:8px; border-radius:10px; align-items:center; cursor:pointer; background:transparent;
  transition: background .12s ease, transform .08s ease;
}
.item-row:hover { background: rgba(0,0,0,0.03); transform: translateY(-1px); }

/* выбранный элемент — подсветка */
.item-row.selected {
  background: linear-gradient(180deg, rgba(218,219,219,0.35), rgba(218,219,219,0.05));
  box-shadow: 0 6px 18px rgba(0,0,0,0.06);
  transform: none;
}

.meta { flex:1 }

/* grid для пар label/value */
.row {
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 12px;
  align-items: start;
  margin: 2px 0;
}

.label {
  color: #888;
  font-size: 13px;
  white-space: nowrap;
  align-self: start;
}
.value {
  color: #222;
  font-weight: 700;
  overflow-wrap: anywhere;
  word-break: break-word;
  white-space: normal;
}
.empty { padding:12px; color:#666; text-align:center }

/* адаптив: на узких экранах — растянуть по ширине и сместить левый отступ */
@media (max-width: 900px) {
  .items-drawer {
    left: 12px;
    right: 12px;
    min-width: 0;
    max-width: calc(100% - 24px);
  }
  .items-drawer.open {
    max-height: calc(100vh - var(--filters-top, calc(var(--header-height,64px) + var(--top-controls-height,72px))) - (var(--map-footer-space, 88px) + 12px));
  }
}

@media (max-width: 520px) {
  .items-drawer { left: 8px; right: 8px; border-radius: 10px; padding: 6px; }
  .drawer-header h3 { font-size:15px }
}
</style>

